module.exports = __webpack_public_path__ + "a6a88883aa24bd6881f928115b3f2f91.png";